/**
 * ⑩ INTELLIGENCE — WITH DRILL-DOWN
 * UC-29: TargetTracking — L1 targets → L2 detail + progress → L3 per-year evidence
 */
import { useState, useEffect } from "react";
import { C, api, post, patch, Btn, Card, Label, Val, Input, Badge, Err, MetricBar, Loader,
         Breadcrumb, DrillRow, DetailPanel, TabBar, HistoryTab, EmptyState, KPICard, LinkedEntity } from "./shared";

// ═══ UC-29: TARGET TRACKING ═══
export function TargetTracking() {
  const [targets,setTargets]=useState([]); const [sel,setSel]=useState(null); const [tab,setTab]=useState("Overview");
  useEffect(()=>{api("/targets/").then(r=>setTargets(r.targets||[])).catch(()=>{});},[]);
  const drillTarget=async(t)=>{setSel(null);try{setSel(await api(`/targets/${t.target_id}`));}catch(e){setSel(t);}setTab("Overview");};
  return (<div data-testid="target-tracking-panel">
    <Breadcrumb path={[{label:"Targets",onClick:()=>setSel(null)},...(sel?[{label:sel.name?.slice(0,30)||"Target"}]:[])]}/>
    {!sel&&<>{targets.map((t,i)=>(<DrillRow key={i} onClick={()=>drillTarget(t)}
      cols={[<span style={{fontWeight:600}}>{t.name||"Target"}</span>,`${t.base_year} to ${t.target_year}`,
        <Badge text={`-${Math.round((t.target_pct_reduction||0)*100)}%`} color={C.emerald}/>,
        <Badge text={t.status||"active"} color={t.status==="active"?C.emerald:C.amber}/>]}/>))}
      {targets.length===0&&<EmptyState message="No targets set"/>}</>}

    {sel&&<DetailPanel visible onClose={()=>setSel(null)} title={sel.name||"Target"} color={C.emerald}>
      <TabBar tabs={["Overview","Progress","Evidence","History"]} active={tab} onChange={setTab}/>
      {tab==="Overview"&&<div><div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:8}}>
        <div><Label>Base Year</Label><Val>{sel.base_year}</Val></div>
        <div><Label>Base Value</Label><Val>{sel.base_value?.toLocaleString()}</Val></div>
        <div><Label>Target Year</Label><Val>{sel.target_year}</Val></div>
        <div><Label>Reduction</Label><Val color={C.emerald}>{Math.round((sel.target_pct_reduction||0)*100)}%</Val></div></div>
        <div style={{marginTop:8,display:"flex",gap:8}}>
          <Badge text={sel.framework||"SBTi"} color={C.teal}/><Badge text={sel.alignment||"1.5C"} color={C.blue}/>
          {sel.validated&&<Badge text="Validated" color={C.emerald}/>}</div></div>}
      {tab==="Progress"&&<div>{(sel.progress||[]).map((p,i)=>{
        const onTrack=p.actual_value<=p.linear_pathway_value;
        return (<DrillRow key={i} onClick={()=>{}} active={false}
          cols={[<span style={{fontWeight:600}}>{p.year}</span>,
            <span style={{color:C.text}}>{p.actual_value?.toLocaleString()} tCO2e</span>,
            <span style={{color:C.dim}}>Linear: {p.linear_pathway_value?.toLocaleString()}</span>,
            <Badge text={onTrack?"On Track":"Behind"} color={onTrack?C.emerald:C.red}/>]}/>);})}
        {(!sel.progress||sel.progress.length===0)&&<div style={{color:C.muted,fontSize:11}}>No progress data recorded yet.</div>}</div>}
      {tab==="Evidence"&&<div style={{color:C.muted,fontSize:11}}>Click any progress year above to drill into linked evidence records for that year's reported value.</div>}
      {tab==="History"&&<HistoryTab resourceId={sel.target_id}/>}
    </DetailPanel>}
  </div>);
}
